import type { TechnicalDataResponse } from './responseTypes/technical-data-response-data';
import BFFAPI from './utils/BFFAPI';

class TechnicalDataAPI extends BFFAPI {
  getTechnicalData = (assetId: AssetId) => {
    const req = this.fetchHelper.createGetRequest(
      `${this.endpoint}/${assetId}`
    );
    return this.fetch<TechnicalDataResponse>(req);
  };
}

export default new TechnicalDataAPI('/fleet/secure/technical-data');
